/**
 * ActiVet® Breed Search Logic
 * Handles real-time search, automatic homepage result toggling, and Favorites
 */

const breedMap = { 
  'german shepherd': 'double-thick', 'husky': 'double-thick', 'golden retriever': 'double-thick', 
  'labrador': 'short-smooth', 'pitbull': 'short-smooth', 'boxer': 'short-smooth',
  'poodle': 'curly-doodle', 'doodle': 'curly-doodle', 'goldendoodle': 'curly-doodle',
  'yorkie': 'long-silky', 'maltese': 'long-silky',
  'schnauzer': 'wire-terrier', 'terrier': 'wire-terrier',
  'puppy': 'puppy'
};

const collectionInfo = {
  'double-thick': { title: 'Dichte Unterwolle', desc: 'Dichte Unterwolle braucht feste, tief greifende Borsten.' },
  'short-smooth': { title: 'Kurz & Glatt', desc: 'Entfernt loses Haar sofort und erhält ein glattes, natürliches Fell.' },
  'curly-doodle': { title: 'Lockig / Doodle', desc: 'Anspruchsvolles Fell braucht spezialisierte Werkzeuge und das Mat-Zapper-System.' },
  'long-silky': { title: 'Lang & Seidig', desc: 'Feines Haar braucht sanftes, entwirrendes Bürsten mit extra Flex.' },
  'wire-terrier': { title: 'Drahthaar', desc: 'Erhält die raue Struktur mit starken Borsten in Profi-Qualität.' },
  'puppy': { title: 'Welpe / Sensibel', desc: 'Der sanfteste Start für eine positive erste Pflege-Erfahrung.' }
};

document.addEventListener('DOMContentLoaded', () => {
    const searchInput = document.querySelector('.hero-search-input');
    
    if (searchInput) {
        let feedbackEl = document.getElementById('search-feedback');
        if (!feedbackEl) {
            feedbackEl = document.createElement('div');
            feedbackEl.id = 'search-feedback';
            feedbackEl.className = 'absolute top-full left-0 right-0 mt-2 bg-white/90 backdrop-blur-sm border border-gray-200 p-3 rounded-xl shadow-xl z-50 hidden text-center transition-all duration-300';
            searchInput.parentNode.style.position = 'relative';
            searchInput.parentNode.appendChild(feedbackEl);
        }

        searchInput.addEventListener('input', (e) => {
            const val = e.target.value.toLowerCase().trim();
            if (val.length < 3) {
                feedbackEl.classList.add('hidden');
                return;
            }

            const match = Object.keys(breedMap).find(b => b.includes(val));

            if (match) {
                const handle = breedMap[match];
                const info = collectionInfo[handle];
                
                feedbackEl.innerHTML = `<p class="text-sm font-medium text-gray-900">ActiVet recognized: <strong class="text-[#C5A059] capitalize">${match}</strong></p>`;
                feedbackEl.classList.remove('hidden');

                if (typeof window.showKitResults === "function") {
                    setTimeout(() => {
                        window.showKitResults(info.title, info.desc, handle);
                        feedbackEl.classList.add('hidden');
                        searchInput.value = ""; 
                        searchInput.blur(); 
                    }, 500); 
                }
            } else {
                feedbackEl.innerHTML = `<p class="text-xs text-gray-400">Searching breeds...</p>`;
                feedbackEl.classList.remove('hidden');
            }
        });
    }

    // Initialize Favorites and Badge on page load
    initFavoriteLogic();
    updateFavoritesBadge();
});

/**
 * Update Header Badge
 */
function updateFavoritesBadge() {
  const badge = document.getElementById('favorites-count-badge');
  if (!badge) return;

  const favorites = JSON.parse(localStorage.getItem('activet_favorites')) || [];
  if (favorites.length > 0) {
    badge.innerText = favorites.length;
    badge.classList.remove('hidden');
  } else {
    badge.classList.add('hidden');
  }
}

/**
 * Handle Product Favorites
 */
function initFavoriteLogic() {
  const favoriteBtns = document.querySelectorAll('.favorite-toggle');
  let favorites = JSON.parse(localStorage.getItem('activet_favorites')) || [];

  favoriteBtns.forEach(btn => {
    // Ensure ID is a string for consistent comparison
    const productId = String(btn.dataset.productId);
    
    if (favorites.includes(productId)) {
      btn.classList.add('is-active');
    }

    btn.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      favorites = JSON.parse(localStorage.getItem('activet_favorites')) || [];

      if (favorites.includes(productId)) {
        favorites = favorites.filter(id => id !== productId);
        btn.classList.remove('is-active');
      } else {
        favorites.push(productId);
        btn.classList.add('is-active');
      }
      
      localStorage.setItem('activet_favorites', JSON.stringify(favorites));
      updateFavoritesBadge();
    };
  });
}

/**
 * AJAX Product Loader
 */
async function loadProductsForHandle(handle) {
    const container = document.getElementById('dynamic-kit-products');
    if (!container) return;
    
    container.innerHTML = `<div class="py-20 text-center font-bold uppercase tracking-widest opacity-50">Curating your kit...</div>`;

    try {
        const response = await fetch(`/collections/${handle}?view=ajax`);
        const html = await response.text();
        container.innerHTML = html;
        
        // Re-initialize for new elements
        initFavoriteLogic();
        if (typeof initActivetCartLogic === 'function') initActivetCartLogic();
        
    } catch (err) {
        console.error('Failed to load products:', err);
        container.innerHTML = `<p class="text-center py-10">Error loading kit. Please try again.</p>`;
    }
}